import RestClient from 'rest_client/rest_client';

import BehaviorsEngine from "../../behaviors_engine/behaviors_engine";
import FormRuleActionListener from "../rules_engine/form_rule_action_listener";
import { FormEventHandler, FormEvents } from "../events/form_event_handler";
import ResponseHandler from '../../rest_client/response_handler';

import SearcherTypes from '../../searcher/searcher_types';

import { JavascriptActions } from './javascript_store';

import BaseReflux from '../../reflux/base_reflux.js';
import LecomRefluxActons from '../../reflux/lecom_reflux_actions';

import LoadFormDefinitionActionHandler from '../handlers/load_form_definition_action_handler';
import LoadInitialValuesActionHandler from '../handlers/load_initial_values_action_handler';
import ExecuteActionHandler from '../handlers/execute_action_handler';

import { setAjaxSetup } from '../../rest_client/interceptors/access_interceptor.js'

import GridFormDefaultActions from '../../grid_form/constants/grid_form_default_actions';
import GridFormAction from '../../form/models/action/grid_form_action'; // nem ta usando isso
import FormActionTypes from '../../form/constants/form_action_types';

import { FormAPI, ProcessAPI } from 'lecom-api';
import ActivityStatuses from "../../process/constants/activity_statuses";

let loadFormDefinitionDone = false;
let loadInitialValuesDone = false;
let initialValues = null;

export const FormActions = Reflux.createActions([
	'loadFormDefinition',
	'setFieldProperties',
	'setGridFieldProperties',
	'setActionProperties',
	'setFieldActionProperties',
	'setGridFieldActionProperties',
	'loadInitialValues',
	'changeField',
	'changeFieldTriggerRules',
	'executeAction',
	'executeFieldAction',
	'executeGridFieldAction'

].concat(LecomRefluxActons));

export const FormStore = Reflux.createStore(Object.assign(BaseReflux, {
	listenables: FormActions,
	eventHandler: FormEventHandler,
	events: FormEvents,
	rulesEngine: null,
	store: {},

	/* Action handlers */

	onInit(props) {
		this.store[props.id] = Object.assign({}, props, {
			errors: {},
			formLoaded: false,
			formLoadedWithErrors: false,
		});

		if (props.formLoaded) {
			this._postInit(props.id)
		} else if (!props.hasOwnProperty("loadOnInit") || props.loadOnInit) {
			this.onLoadFormDefinition(props.id);
		}
	},

	_postInit(itemId) {
		$('body').off('keyup keydown', '.materialize-textarea');
		Materialize.updateTextFields();

		this._initFormRulesEngine(itemId);

		this._publish(this.events.INIT, ...arguments);
	},

	/* Form definition loader */

	onLoadFormDefinition(itemId, url, params) {
		loadFormDefinitionDone = false;

		var params = {
			id: itemId,
			definitionURL: this.store[itemId].definitionURL,
			definitionParams: this.store[itemId].definitionParams
		}				

		LoadFormDefinitionActionHandler.execute(params)
			.then(this._handleFormDefinitionLoad.bind(this, itemId))
			.catch(this._handleFormDefinitionLoadError.bind(this, itemId))
	},

	_buildActionProps(formId, actions, field) {
		for (let contAction = 0, lenActions = actions.length; contAction < lenActions; contAction++) {
			actions[contAction].formId = formId;
			if (field) {
				actions[contAction].parentFieldId = field.id;
				actions[contAction].gridFormParent = field.gridFormParent;
			}
		}
	},

	_buildPropsField(formId, fields) {
		for (let index in fields) {
			let field = fields[index];
			field.formId = formId;
			field.rawValue = "";

			this._buildActionProps(formId, field.actions, field);

			if (field.fields) {
				field.actions = GridFormDefaultActions.map((action) => Object.assign({
					formId: formId,
					type: FormActionTypes.GRID
				}, action));
				this._buildPropsField(formId, field.fields);
			}
		}
	},

	_handleFormDefinitionLoad(itemId, response) {		
		loadFormDefinitionDone = true;	

		var formDefinition = response.entity.form;		
		var envDefinition = response.entity.environment;
		let contextPath = "/form-app";

		if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_MOCK) {
			contextPath = process.env.REACT_APP_CONTEXT_PATH;
		}
		else {
			contextPath = envDefinition.contextPath;
		}

  		window.contextPath = contextPath;

		ProcessAPI.currentProcess().isPublic(formDefinition.publicForm.enabled);
		ProcessAPI.currentProcess().dataPrintEnabled(envDefinition.dataPrintEnabled);
		ProcessAPI.currentProcess().gatewayUrl(envDefinition.gatewayUrl);
		ProcessAPI.currentProcess().isECMLicenseFull(envDefinition.isECMLicenseFull);
		ProcessAPI.currentProcess().lecomBpmUrl(envDefinition.lecomBpmUrl);
		ProcessAPI.currentProcess().timeZone(envDefinition.timeZone);

		formDefinition.formId = formDefinition.id;
		formDefinition.id = itemId;
		//Adicionando props no campo
		let fields = $.extend(true, [], formDefinition.fields);
		delete formDefinition.fields;
		formDefinition.fields = {};		

		fields.forEach(field => {
			formDefinition.fields[field.name] = field;
		});		

		this._buildPropsField(itemId, formDefinition.fields);
		this._buildActionProps(itemId, formDefinition.actions);

		formDefinition.actions.reverse();		
		
		Object.assign(this.store[itemId], formDefinition);		
			
		this.store[itemId].DEFINITION_LOAD_SUCCESS = {itemId, formDefinition, response}		

		this.trigger(
			Object.assign(formDefinition, { id: itemId }),
			() => {				
				setAjaxSetup();
				this._postInit(itemId);

				if (loadInitialValuesDone) {
					if (initialValues)		
						this._setInitialValues(itemId, initialValues);							
					else
						this.initialValuesLoadSuccess(itemId, initialValues);						
				}
			
				// this._publish(this.events.DEFINITION_LOAD_SUCCESS, itemId, formDefinition, response)
				// 	.then(this._postInit.bind(this, itemId))
				// 	.then(this._publish.bind(this, this.events.INIT, itemId, formDefinition))
			}
		)
	},

	_handleFormDefinitionLoadError(itemId, response) {
		if (response.message === 'IsEntityResponseEmpty') return;

		loadFormDefinitionDone = true;

		this.trigger({
			id: itemId,
			formLoadedWithErrors: true
		}, () => {
			ResponseHandler.displayErrorResponseFlashMessage("flash-form", response);
		});
	},

	/* Initial values loader */

	onLoadInitialValues(itemId) {
		loadInitialValuesDone = false;

		const storeItem = this.store[itemId];

		return LoadInitialValuesActionHandler
			.execute({
				id: itemId,
				initialValuesDataStoreRoute: storeItem.initialValuesDataStoreRoute
			})
			.then(this._handleLoadInitialValuesSuccess.bind(this, itemId))
			.catch(this._handleLoadInitialValuesError.bind(this, itemId));
	},

	_handleLoadInitialValuesSuccess(itemId, initialValuesResponse) {
		loadInitialValuesDone = true;
		initialValues = initialValuesResponse;		

		if (loadFormDefinitionDone) {
			if (initialValuesResponse)
				this._setInitialValues(itemId, initialValuesResponse);
			else
				this.initialValuesLoadSuccess(itemId, initialValuesResponse);
		}
	},

	_setInitialValues(itemId, initialValuesResponse) {		
		var fieldsUpdate = {};
		var formApi = FormAPI.form(itemId);											
		if (initialValuesResponse) {			
			for (let cont = 0, len = initialValuesResponse.length; cont < len; cont++) {				
				let fieldInitialValue = initialValuesResponse[cont];
				
				if (fieldInitialValue.value || typeof fieldInitialValue.value === "number") {					
					fieldsUpdate[fieldInitialValue.fieldId] = { value: fieldInitialValue.value };
					
					if (fieldInitialValue.gridId) {						
						const isGrid = formApi.fields(fieldInitialValue.gridId).fields !== undefined;
						if(isGrid){							
							formApi.fields(fieldInitialValue.gridId).fields(fieldInitialValue.fieldId).value(fieldInitialValue.value);
						}
					} else {						
						const isGrid = formApi.fields(fieldInitialValue.fieldId).fields === undefined;						

						if (isGrid) {							
							formApi.fields(fieldInitialValue.fieldId).value(fieldInitialValue.value);							
						}
					}
				}
			}
		}
		
		formApi.apply().then(this.initialValuesLoadSuccess.bind(this, itemId, initialValuesResponse));		

	},

	loadJavascripts(itemId, script, initialValuesResponse) {
		ProcessAPI.currentProcess().waitingForAction(false).apply();

		this.store[itemId].formLoaded = true;
		this.store[itemId].waitingForAction = false;
		this.store[itemId].initialValues = initialValuesResponse;

		this.trigger({
			id: itemId,
			formLoaded: true,
			waitingForAction: false,
			initialValues: initialValuesResponse
		}, () => {
			if (script)
				JavascriptActions.loadJavascripts({ customScript: [script] });
			else
				JavascriptActions.loadJavascripts();
		});

		const data = this.store[itemId].DEFINITION_LOAD_SUCCESS;

		this._publish(this.events.DEFINITION_LOAD_SUCCESS, data.itemId, data.formDefinition, data.response)
			.then(this._publish.bind(this, this.events.INIT, data.itemId, data.formDefinition));

	},

	initialValuesLoadSuccess(itemId, initialValuesResponse) {				
		return this._publish(this.events.INITIAL_VALUES_LOAD_SUCCESS, itemId, initialValuesResponse)
			.then(this._loadHistory.bind(this, itemId))
			.then(this._executeRefreshOnLoadActions.bind(this, itemId))
			.then(this._handleProcessActionsEmailOnStart)
			.then((script) => {				
				this.loadJavascripts(itemId, script, initialValuesResponse);
			});
	},

	_loadHistory(itemId) {
		const formAPI = FormAPI.form(itemId);
		const fieldsWithHistory = formAPI.fields()
			.filter(field => field.history());

		if (fieldsWithHistory.length) {
			const fieldsParam = fieldsWithHistory.reduce((before, field) => `${before}&field=${field.id}`, "");
			const { processInstanceId, activityInstanceId, cycle } = ProcessAPI.currentProcess().processIds();

			// return (
				RestClient.get(`/workflow-service/process-instances/business-data/history?activityInstanceId=${activityInstanceId}&processInstanceId=${processInstanceId}&cycle=${cycle}${fieldsParam}`)
					.then(response => {
						if (response && response.entity && response.entity._embedded) {
							const { fieldHistoryValues } = response.entity._embedded;
							fieldHistoryValues.forEach(fieldHistory => {
								formAPI.fields(fieldHistory.field).historyProps(fieldHistory.history);
							});
							formAPI.apply();
						}
					})
			// )
		}

		return Promise.resolve();
	},

	_executeRefreshOnLoadActions(itemId) {

		const formStoreItem = this.store[itemId];
		const formFileds = formStoreItem.fields;
		let refreshActions = formStoreItem.actions;

		for (let formField in formFileds) {
			const currentField = formFileds[formField];
			const typeField = currentField.type;

			if (typeField === 'GRID') {
				const gridFields = currentField.fields;

				for (let fieldGrid in gridFields) {
					const currentFieldGrid = gridFields[fieldGrid];
					let actionGridField = currentFieldGrid.actions;

					if (actionGridField && Array.isArray(actionGridField) && actionGridField.length) {
						refreshActions = refreshActions.concat(actionGridField);
					}
				}
			}

			let actionFormField = currentField.actions;

			if (actionFormField && Array.isArray(actionFormField) && actionFormField.length) {
				refreshActions = refreshActions.concat(actionFormField);
			}
		}

		for (let cont = 0, len = refreshActions.length; cont < len; cont++) {
			let action = refreshActions[cont];

			if (this._hasRefreshOnLoadActions(action) && !formStoreItem.readOnly) {
				this._executeAction(itemId, refreshActions[cont]);
			}
		}

		return Promise.resolve();
	},

	_hasRefreshOnLoadActions(action) {
		return action.searcherType === SearcherTypes.REFRESH && action.searchOnLoad;
	},

	_handleLoadInitialValuesError(itemId, response) {
		if (response.message === 'IsEntityResponseEmpty') return;

		loadInitialValuesDone = true;
		
		this.trigger({
			id: itemId,
			formLoadedWithErrors: true
		}, () => {
			ResponseHandler.displayErrorResponseFlashMessage("flash-form", response);
		});
	},

	_handleProcessActionsEmailOnStart() {
		const process = ProcessAPI.currentProcess();
		const actionEmail = process.actionEmail();
		let scriptEmail = '';

		if (actionEmail) {
			scriptEmail = `
				var form = Lecom.api.ProcessAPI.currentProcess().form();
				let action;
				if ('${actionEmail}' === '${ActivityStatuses.APPROVED}') {
					action = form.actions('aprovar') ? form.actions('aprovar') : form.actions('finish');
					if (action) {
						action.execute();
					}
				} else if ('${actionEmail}' === '${ActivityStatuses.REJECTED}') {
					action = form.actions('cancel') ? form.actions('cancel') : form.actions('rejeitar');
					if (action) {
						action.execute();
					}
				}
			`;
		}
		return Promise.resolve(scriptEmail)
	},

	/* Field properties getters */

	getFieldProperties(itemId, fieldId, ...properties) {
		return this._getFormField(itemId, fieldId);
	},

	getGridFieldProperties(itemId, gridId, fieldId, ...properties) {
		return this._getGridField(itemId, gridId, fieldId);
	},

	/* Field properties setters */

	onSetFieldProperties(itemId, fieldId, properties, trigger = true) {
		const payload = this.buildPayloadSetFieldPropertiesEvent(null, fieldId, properties, trigger);
		const formField = this._getFormField(itemId, fieldId);
		this._setProperties(itemId, formField, properties, trigger)
			.then(this._publish.bind(this, this.events.SET_FIELD_PROPERTIES, itemId, payload));
		return formField
	},

	onSetGridFieldProperties(itemId, gridId, fieldId, properties, trigger = true) {
		const payload = this.buildPayloadSetFieldPropertiesEvent(gridId, fieldId, properties, trigger);
		const gridField = this._getGridField(itemId, gridId, fieldId);
		this._setProperties(itemId, gridField, properties, trigger)
			.then(this._publish.bind(this, this.events.SET_FIELD_PROPERTIES, itemId, payload));
		return gridField;
	},

	buildPayloadSetFieldPropertiesEvent(gridId, fieldId, properties, trigger) {
		return { gridId, fieldId, properties, trigger };
	},

	/* Action properties getters */

	getActionProperties(itemId, actionId) {
		return this._getFormAction(itemId, actionId);
	},

	getFieldActionProperties(itemId, fieldId, actionId) {
		return this._getFieldAction(itemId, fieldId, actionId);
	},

	getGridFieldActionProperties(itemId, gridId, fieldId, actionId) {
		return this._getGridFieldAction(itemId, gridId, fieldId, actionId);
	},

	/* Action properties setters */

	onSetActionProperties(itemId, actionId, properties, trigger = true) {
		var formAction = this._getFormAction(itemId, actionId);
		var publish = this._publish.bind(this, this.events.SET_ACTION_PROPERTIES, itemId, actionId, properties);
		return this._setProperties(itemId, formAction, properties, trigger).then(publish);
	},

	onSetFieldActionProperties(itemId, fieldId, actionId, properties, trigger = true) {
		var fieldAction = this._getFieldAction(itemId, fieldId, actionId);
		var publish = this._publish.bind(this, this.events.SET_ACTION_PROPERTIES, itemId, actionId, properties);
		return this._setProperties(itemId, fieldAction, properties, trigger).then(publish);
	},

	onSetGridFieldActionProperties(itemId, gridId, fieldId, actionId, properties, trigger = true) {
		var gridFieldAction = this._getGridFieldAction(itemId, gridId, fieldId, actionId);
		var publish = this._publish.bind(this, this.events.SET_ACTION_PROPERTIES, itemId, actionId, properties);
		return this._setProperties(itemId, gridFieldAction, properties, trigger).then(publish);
	},

	/* Action executors */

	onExecuteAction(itemId, actionId) {
		const formAction = this._getFormAction(itemId, actionId);
		this._executeAction(itemId, formAction);
	},

	onExecuteFieldAction(itemId, fieldId, actionId) {
		const fieldAction = this._getFieldAction(itemId, fieldId, actionId);
		this._executeAction(itemId, fieldAction);
	},

	onExecuteGridFieldAction(itemId, gridId, fieldId, actionId) {
		const gridFieldAction = this._getGridFieldAction(itemId, gridId, fieldId, actionId);
		this._executeAction(itemId, gridFieldAction);
	},

	/* Private functions */

	_getFormField(itemId, fieldId) {
		const formStoreItem = this.store[itemId];
		const formField = formStoreItem.fields[fieldId];
		if (!formField) {
			throw new Error(`Form Field not found for id: ${fieldId}`);
		}

		return formField;
	},

	_getGridField(itemId, gridId, fieldId) {
		const formField = this._getFormField(itemId, gridId);
		if (formField.component !== "gridform") {
			throw new Error(`Form Field with id ${gridId} is not a Grid`);
		}

		// const gridField = formField.fields[fieldId];
		const gridField = formField.fields.find(field => field.id === fieldId);
		if (!gridField) {
			throw new Error(`Grid Field not found for id: ${fieldId}`);
		}

		return gridField;
	},

	_getFormAction(itemId, actionId) {
		const storeItem = this.store[itemId];
		const formAction = storeItem.actions.find((a) => a.id === actionId);
		if (!formAction) {
			throw new Error(`Form Action not found for id: ${actionId}`);
		}

		return formAction;
	},

	_getFieldAction(itemId, fieldId, actionId) {
		const formField = this._getFormField(itemId, fieldId);
		const fieldAction = formField.actions.find((a) => a.id === actionId);

		if (!fieldAction) {
			throw new Error(`Field Action not found for id: ${actionId}`);
		}

		return fieldAction;
	},

	_getGridFieldAction(itemId, gridId, fieldId, actionId) {
		const gridField = this._getGridField(itemId, gridId, fieldId);
		const gridFieldAction = gridField.actions.find((a) => a.id === actionId);

		if (!gridFieldAction) {
			throw new Error(`Grid Field Action not found for id: ${actionId}`);
		}

		return gridFieldAction;
	},

	_executeAction(itemId, action) {
		this._publish(this.events.EXECUTE_ACTION, itemId, action.id);
		ExecuteActionHandler
			.execute(action)
			.then(this._publish.bind(this, this.events.EXECUTE_ACTION_SUCCESS, itemId, action.id))
			.catch(this._publish.bind(this, this.events.EXECUTE_ACTION_ERROR, itemId, action.id));
	},

	/* Initializers */

	initFormEventListener() { },

	/* Rules Engine handlers */

	_initFormRulesEngine(itemId) {
		return BehaviorsEngine.init({ formStoreId: itemId });
	},

}));

export default FormStore;
